import { Rules } from "src/lib/permission/types";
import { rolRules } from "./rol";

export const allPermission: Rules[] = [...rolRules];
